const mainColors = {
  primary: '#008080',
  purple: '#8b4dc6',
  brown: '#d08c6e',
  pink: '#d3004b',
  neutral: '#b5bcc7',
  success: '#419745',
  warning: '#db8300',
  danger: '#ce4745',
  info: '#569cd4',
};

export const colors = {
  light: {
    bg: '#f7f9fc',
    surface: '#ffffff',
    surfaceAlt: '#f1f3f6',
    text: 'rgba(0, 0, 0, 0.87)',
    textMuted: 'rgba(0, 0, 0, 0.6)',
    border: 'rgba(0, 0, 0, 0.1)',
    divider: 'rgba(0, 0, 0, 0.1)',
    ...mainColors,
  },
  dark: {
    bg: '#181818',
    surface: '#202025',
    surfaceAlt: '#202025',
    text: '#FFFFFF',
    textMuted: 'rgba(255, 255, 255, 0.7)',
    border: 'rgba(255, 255, 255, 0.14)',
    divider: 'rgba(255, 255, 255, 0.14)',
    ...mainColors,
  },
} as const;

export type ColorMode = keyof typeof colors;
